import { FC, useMemo } from 'react'
import { Box, HStack, Image, VStack, useRadioGroup } from '@chakra-ui/react'
import { useSelector } from 'react-redux'
import { RadioButtonProps } from '../radio-buttons/interfaces'
import { cardImageMap } from '../../state/interfaces'
import { selectScenarioIsWaitingForAnswer } from '../../state'
import { LoadingNewAnswer } from '../spinners/loading-new-answer'

const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.planhubca.apps'
const GOOGLE_PLAY_ANSWER = 'google-play'

interface Choice {
  value: string
  label: string
  image?: string
  isChecked?: boolean
}

export interface AndroidAppProps {
  name: string
  choices: Choice[]
  value?: string
  onChange?: (values: string[]) => void
  component: FC<RadioButtonProps>
  grandImage?: string
}

export const androidApp: FC<AndroidAppProps> = ({
  choices,
  value,
  onChange,
  name,
  component: Component,
  grandImage,
}) => {
  const scenarioIsWaitingForAnswer = useSelector(selectScenarioIsWaitingForAnswer)
  const image = useMemo(() => (grandImage ? cardImageMap[grandImage] : ''), [grandImage])

  const { getRadioProps, getRootProps } = useRadioGroup({
    onChange: (selectedValue) => onChange && onChange([selectedValue]),
    value,
    name,
  })

  const redirectToGooglePlay = () => {
    onChange && onChange([GOOGLE_PLAY_ANSWER])
    window.location.assign(GOOGLE_PLAY_URL)
  }

  return (
    <VStack spacing={4} width="100%" alignItems="center">
      <Box marginTop={8} width="100%" display="flex" justifyContent="center">
        {image && (
          <Box
            as="button"
            type="button"
            onClick={redirectToGooglePlay}
            background="transparent"
            border="none"
            padding={0}
            cursor="pointer"
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
          >
            <Image src={image} alt="Google Play" maxW={{ base: '220px', md: '260px' }} width="100%" />
          </Box>
        )}
      </Box>
      <HStack {...getRootProps()} justifyContent="center" width="100%" marginTop={4}>
        {scenarioIsWaitingForAnswer ? (
          <LoadingNewAnswer />
        ) : (
          choices.map((props) => (
            <Component key={`choice-${props.value}`} {...getRadioProps({ value: props.value })} {...props} />
          ))
        )}
      </HStack>
    </VStack>
  )
}
